import * as PIXI from "pixi.js";
import TextureManager from "./managers/TextureManager";
import Game from "./screens/Game";
import Animation from "./animations/Animation";
import calculateScale from "./helper/calculateScale";
import SoundManager from "./managers/SoundManager";

import LoadingPage from "./entities/LoadingPage";

export default class Main extends PIXI.Application {
  static instance: Main;
  innerW = window.innerWidth;
  innerH = window.innerHeight;
  SCALE = 1;
  WIDTH = 1280;
  HEIGHT = 630;
  Animation = new Animation();
  loadingPage: LoadingPage;
  constructor(view: HTMLCanvasElement) {
    super();
    if (!Main.instance) {
      Main.instance = this;
    }
    const scaleDetails = calculateScale(this.WIDTH, this.HEIGHT, this.innerW, this.innerH);
    this.SCALE = scaleDetails.scale;
    this.WIDTH = scaleDetails.width;
    this.HEIGHT = scaleDetails.height;
    view.style = `transform:scale(${this.SCALE})`
    this.init({
      view: view,
      antialias: true,
      width: this.WIDTH,
      height: this.HEIGHT,
      backgroundAlpha: 0
    }).then(() => {
      console.log("Game is started");
      TextureManager.loadLogo().then(() => {
        this.loadingPage = new LoadingPage();
        TextureManager.load((v: number) => this.loadingPage.drawLoadingBar(v)).then((a) => SoundManager.load().then((s) => {
          console.log("loaded textures and sounds")
          this.loadingPage.remove();
          new Game();
          SoundManager.playBgSound();

          this.ticker.add(delta => this.update(delta))
        }))
      })

    })
  }
  static getInstance(): Main {
    return Main.instance;
  }

  getDim() {
    return { width: this.WIDTH, height: this.HEIGHT };
  }
  update(delta: PIXI.Ticker) {
    this.Animation.update(delta.lastTime);
  }
}

const canvas = document.querySelector("#canvas") as HTMLCanvasElement;

if (canvas) {
  (window as any).context = new Main(canvas)
} else {
  console.error("Canvas is not found")
}

document.addEventListener("DOMContentLoaded", function() {
  const video = document.querySelector("#video") as HTMLVideoElement;
  video!.muted = true;
  video!.play().catch(error => console.log("blocked automatic playing:", error));
});